import React from 'react';

const Vue_v_html = () => {
  return (
    <div>
      <h1>Vue_v_html Component</h1>
      <p>This is the Vue_v_html tutorial page.</p>
    </div>
  );
}

export default Vue_v_html;
